import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { BBIDService } from '@core/services/bbid.service';
import { PortalDeterminationService } from '@core/services/portal-determination.service';
import { TokenService } from '@core/services/token/token.service';
import { TranslationService } from '@core/services/translation.service';
import { UserTosService } from '@core/services/user-tos.service';
import { ClientSettingsService } from '@features/client-settings/client-settings.service';
import { ClientUserService } from '@features/client-user/client-user.service';

export const canAccessPortalGuard: CanActivateFn = async (
  activatedRouteSnapshot: ActivatedRouteSnapshot
) => {
  const tokenService = inject(TokenService);
  const portal = inject(PortalDeterminationService);
  const authService = inject(AuthService);
  const router = inject(Router);
  const bbidService = inject(BBIDService);
  const translationService = inject(TranslationService);
  const clientUserService =  inject(ClientUserService);
  const clientSettingsService = inject(ClientSettingsService);
  const userTosService = inject(UserTosService);
  if (!tokenService.getIsLoggedIn()) {
    tokenService.setAttemptedRoute();
  }

  const queryParams = activatedRouteSnapshot.queryParams as {
    svcId: string;
    envId: string;
    alreadyLoggedInWithBbid: boolean;
  };

  const svcId = queryParams.svcId || tokenService.bbidSvcId;
  const envId = queryParams.envId || tokenService.bbidEnvId;
  const isGcBbid = bbidService.isGrantsConnectBbid(svcId, envId);
  const isBbgm = !!svcId && !!envId && !isGcBbid;
  const isBbid = tokenService.isBbid;
  const clientId = tokenService.clientId;
  const alreadyLoggedInWithBbid = activatedRouteSnapshot.queryParams.alreadyLoggedInWithBbid === 'true' ? true : false;
  // Don't login with BBID twice if we already signed in
  if ((isBbgm || isBbid) && !alreadyLoggedInWithBbid) {
    const passed = await authService.loginWithBbid(
      svcId,
      envId,
      false,
      false,
      '',
      false,
      clientId,
      true
    );
    if (!passed) {
      return false;
    }
  }

  if (!tokenService.getIsLoggedIn()) {
    router.navigateByUrl(`/${portal.routeBase}/auth/signin`);

    return false;
  }


  portal.isManager ?
    await clientSettingsService.prepareClientAndSubdomain() :
    null;

  await Promise.all([
    clientUserService.resolveUser(),
    translationService.setViewTranslations(false)
  ]);

  if (!tokenService.hasImpersonationToken() && !tokenService.isBbid) {
    return userTosService.ensureTermsOfServiceAccepted();
  }

  return true;

};

